(function () {
  function parseJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (_e) {
      return null;
    }
  }

  function updatePriceText(priceWrap, formatted) {
    if (!priceWrap || !formatted) return;
    var item = priceWrap.querySelector('.price-item--regular, .price-item--sale, .price-item');
    if (item) item.textContent = formatted;
  }

  function initRetailSellingPlan(root) {
    var formId = root.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : root.closest('form');
    if (!form) return;

    var data = parseJson(root.querySelector('[data-retail-selling-plan-json]'));
    if (!data || !data.variants) return;

    var planInput = root.querySelector('[data-retail-selling-plan-input]');
    var planSelect = root.querySelector('[data-retail-plan-select]');
    var freqWrap = root.querySelector('[data-retail-plan-frequency]');
    var purchaseRadios = root.querySelectorAll('input[name="purchase_type"]');
    var priceSelector = root.getAttribute('data-price-selector');
    var priceWrap = priceSelector ? document.querySelector(priceSelector) : null;
    var variantInput = form.querySelector('[name="id"]');

    function isSubscribe() {
      var sub = root.querySelector('input[name="purchase_type"][value="subscribe"]');
      return sub && sub.checked;
    }

    function currentVariantId() {
      return variantInput ? String(variantInput.value) : '';
    }

    function syncSellingPlanInput() {
      if (!planInput) return;
      if (!isSubscribe() || !planSelect) {
        planInput.disabled = true;
        planInput.value = '';
        return;
      }
      planInput.disabled = false;
      planInput.value = planSelect.value;
    }

    function syncFrequencyVisibility() {
      if (!freqWrap) return;
      freqWrap.hidden = !isSubscribe();
    }

    function applyPrice() {
      syncFrequencyVisibility();
      syncSellingPlanInput();

      var vid = currentVariantId();
      var variantData = data.variants[vid];
      if (!variantData) return;

      var formatted = variantData.oneTime;
      if (isSubscribe() && planSelect && variantData.plans) {
        formatted = variantData.plans[planSelect.value] || formatted;
      }
      updatePriceText(priceWrap, formatted);
    }

    purchaseRadios.forEach(function (radio) {
      radio.addEventListener('change', applyPrice);
    });
    if (planSelect) planSelect.addEventListener('change', applyPrice);

    if (variantInput) {
      variantInput.addEventListener('change', applyPrice);
      new MutationObserver(applyPrice).observe(variantInput, {
        attributes: true,
        attributeFilter: ['value'],
      });
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') applyPrice();
    });

    applyPrice();
  }

  function boot() {
    document.querySelectorAll('[data-retail-selling-plan]').forEach(initRetailSellingPlan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
